import { Skeleton } from 'antd';

const CoursesSkeleton = () => {
  return (
    <div className='w-full rounded-md cursor-pointer flex flex-col transition duration-300'>
      <div className='h-full text-fadedWhite flex flex-col'>
        <div className='flex flex-col gap-y-4 items-center h-full gap-x-6'>
          <div className='flex justify-center w-full'>
            <div
              className='w-full flex justify-center h-full relative overflow-hidden'
              style={{ aspectRatio: '2 / 1' }}
            >
              <Skeleton.Image
                className='w-full h-full rounded-md md:rounded-lg'
                active
              />
            </div>
          </div>

          <div className='h-full w-full'>
            <div className='flex justify-between md:flex-col gap-y-3 lg:flex-row items-center h-full w-full gap-x-3'>
              <div className='flex flex-col gap-y-1 h-full w-full justify-center'>
                <Skeleton.Input className='w-3/4' active size='small' />
                <div className='flex gap-x-2 items-baseline '>
                  <Skeleton.Input className='w-1/4' active size='small' />
                </div>
              </div>
              <Skeleton.Button
                className='w-full text-center text-sm'
                active
                size='large'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoursesSkeleton;
